import { render, staticRenderFns } from "./SchemaSection.vue?vue&type=template&id=19230a0a&scoped=true"
import script from "./SchemaSection.vue?vue&type=script&lang=js"
export * from "./SchemaSection.vue?vue&type=script&lang=js"
import style0 from "./SchemaSection.vue?vue&type=style&index=0&id=19230a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19230a0a",
  null
  
)

export default component.exports